@if (busyIndicatorMessageManager.count() > 0) {
    <ws-busy-indicator [message]="busyIndicatorMessageManager.message"></ws-busy-indicator>
}
<ws-modal-wrapper headerLabel="Site Characteristics"
                  subHeaderLabel="Select characteristics to be displayed on tax bill transmittal"
                  [cancelLabel]="(isEditMode) ? 'Cancel' : 'Close'"
                  [suppressKeyboardEvents]="true"
                  auxButtonLabel="Clear All Fields"
                  [hideAuxButton]="!isEditMode"
                  (auxButton)="removeAllSelectedDescriptors()"
                  (save)="save()"
                  (cancel)="cancel()"
                  [hideSave]="!isEditMode"
                  data-qa="site-descriptors-modal">
    <div class="app-ui-view ws-flex-container-vertical ws-flex-auto ws-stretch">
        @if (isInitialized) {
            <table>
                @for (item of selectedDescriptors; track trackByIndex(i, item); let i = $index) {
                    <tr>
                        <td>Characteristic {{ numToWord(i + 1) }}</td>
                        <td>
                            <site-descriptor-selector
                                [descriptors]="siteDescriptors"
                                [descriptorId]="item"
                                [selectedDescriptors]="selectedDescriptors"
                                [disabled]="!isEditMode || i !== 0 && !item && !selectedDescriptors[i - 1]"
                                (descriptorChange)="onDescriptorChange($event, i)"
                                [attr.data-qa]="'site-descriptor-selector-' + i"></site-descriptor-selector>
                        </td>
                    </tr>
                }
            </table>
        }
    </div>
</ws-modal-wrapper>
